import React, { useState } from "react";
import { trackError } from "../../../../lib/metrics";

const CORRECT_CODE = "49271";

export default function LockedFolder({ onSuccess, sessionCode, stage = 2, playerId }) {
  const [code, setCode] = useState("");
  const [error, setError] = useState(false);
  const [status, setStatus] = useState("idle");

  const handleSubmit = (e) => {
    e.preventDefault();
    const cleanInput = code.trim().replace(/\s+/g, "");
    setStatus("checking");

    setTimeout(() => {
      if (cleanInput === CORRECT_CODE) {
        setStatus("success");
        setTimeout(() => { onSuccess?.(); }, 1500);
      } else {
        setError(true);
        setStatus("idle");
        trackError({ sessionCode, stage, playerId, reason: "s2.p4.folder.wrong_code", meta: { attempt: cleanInput } });
        setTimeout(() => setError(false), 2000);
      }
    }, 800);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] py-12 px-4 bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950">
      <div className="w-full max-w-lg space-y-6">
        <div className="text-center space-y-4">
          <div className="w-24 h-24 mx-auto bg-purple-500/10 border-2 border-purple-500/30 rounded-2xl flex items-center justify-center">
            <svg className="w-12 h-12 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div>
            <div className="text-xl font-semibold text-slate-200">FRAGMENT_VALIDATION_04.enc</div>
            <div className="text-sm text-slate-400 mt-2">Fichier chiffré — Code de déverrouillage requis</div>
          </div>
        </div>

        <div className="bg-slate-900/60 border border-slate-700/50 rounded-lg p-4 space-y-2 text-xs">
          <div className="flex justify-between"><span className="text-slate-500">Type</span><span className="text-slate-300 font-mono">Fichier chiffré (.enc)</span></div>
          <div className="flex justify-between"><span className="text-slate-500">Taille</span><span className="text-slate-300 font-mono">2.4 MB</span></div>
          <div className="flex justify-between"><span className="text-slate-500">Modifié</span><span className="text-slate-300 font-mono">23:52:17 - 00:08:14</span></div>
          <div className="flex justify-between"><span className="text-slate-500">Niveau de sécurité</span><span className="text-amber-400 font-mono">ÉLEVÉ</span></div>
        </div>

        <form onSubmit={handleSubmit} className="bg-slate-900/60 border border-slate-700/50 rounded-xl p-6 space-y-5">
          <div>
            <label className="block text-xs uppercase tracking-wider text-slate-400 font-semibold mb-3">
              Code de déverrouillage
            </label>
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="• • • • •"
              disabled={status === "success"}
              maxLength={5}
              className={`
                w-full px-4 py-3 rounded-lg text-center
                bg-black/60 border-2
                ${error ? "border-red-500 text-red-400" : "border-slate-600 text-slate-200"}
                ${status === "success" ? "border-emerald-500 text-emerald-300" : ""}
                font-mono text-2xl tracking-widest
                focus:outline-none focus:border-purple-500
                transition-colors disabled:opacity-50 disabled:cursor-not-allowed
              `}
            />
            {error && (
              <div className="mt-2 text-xs text-red-400 flex items-center gap-2">
                <span>❌</span><span>Code incorrect</span>
              </div>
            )}
            {status === "success" && (
              <div className="mt-2 text-xs text-emerald-400 flex items-center gap-2">
                <span>✓</span><span>Déchiffrement en cours...</span>
              </div>
            )}
          </div>

          <button
            type="submit"
            disabled={status === "checking" || status === "success" || code.length !== 5}
            className={`
              w-full px-4 py-3 rounded-lg font-semibold transition
              ${status === "success"
                ? "bg-emerald-600 text-white"
                : "bg-purple-600 hover:bg-purple-500 text-white disabled:bg-slate-700 disabled:text-slate-500 disabled:cursor-not-allowed"
              }
            `}
          >
            {status === "checking" && (
              <span className="flex items-center justify-center gap-2">
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                Vérification...
              </span>
            )}
            {status === "success" && "Fichier déverrouillé"}
            {status === "idle" && "Déverrouiller"}
          </button>
        </form>
      </div>
    </div>
  );
}